import * as React from 'react';

class Loader extends React.Component<any, State> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  render() {
    return (
      <div className="is-loading customLoad">
        Loading...
	  </div>
    );
  }
}

export default Loader

interface State {
	loading?: boolean
}



// WEBPACK FOOTER //
// ./src/component/loader/index.tsx